<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2024-09-14</p>
    <div class="content">
      <!-- 第一段内容：文章介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>
     
      <!-- 第一个会议标题 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(currentNews.content?.split('---')[1] || '')"></p>
        </div>
      </div>
      
      <!-- 第一个会议内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>
      
      <!-- 第一个会议补充 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>
      
      <!-- 图片部分：第一个会议 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url">
          <p class="image-caption">第11届中国核学会辐照效应分会2024年度学术年会</p>
        </div>
      </div>
      
      <!-- 第二个会议标题 -->
      <div class="content-section">
        <div class="text-block">
            <p v-html="highlightText(currentNews.content?.split('---')[4] || '')"></p>
        </div>
      </div>
      
      <!-- 第二个会议内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[5] || ''"></p>
        </div>
      </div>
      
      <!-- 第二个会议补充 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[6] || ''"></p>
        </div>
      </div>
      
      <!-- 图片部分：第二个会议 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url">
          <p class="image-caption">第二十三次"实用化高温超导材料产学研合作组"暨中国科学院B类先导专项共同例会</p>
        </div>
      </div>
      
      <!-- 第三个会议标题 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(currentNews.content?.split('---')[7] || '')"></p>
        </div>
      </div>
      
      <!-- 第三个会议内容 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[8] || ''"></p>
        </div>
      </div>
      
      <!-- 第三个会议补充1 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[9] || ''"></p>
        </div>
      </div>
      
      <!-- 图片部分：第三个会议展台 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url">
          <p class="image-caption">2024年国际应用超导会议展台</p>
        </div>
      </div>
      
      <!-- 第三个会议补充2 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[10] || ''"></p>
        </div>
      </div>
      
      <!-- 总结部分 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[11] || ''"></p>
        </div>
      </div>
      
      <!-- 主要图片展示 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture4?.url">
          <p class="image-caption">2024年国际应用超导会议现场</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'zhonglianghui');
  return newsItem || {};
});

// 处理高亮文本的函数
const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto; 
}

.content-section {
  margin-bottom: 20px;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
}
</style> 